import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Chapter, FadeIn } from "./Reveal";
import { IMAGES, STATS } from "../data/site";

export const Infrastructure = () => {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ["start end", "end start"],
    });
    const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

    return (
        <section
            id="infrastructure"
            data-testid="infrastructure-section"
            ref={ref}
            className="relative overflow-hidden py-32 md:py-48"
        >
            <motion.div style={{ y }} className="absolute -inset-y-[15%] inset-x-0">
                <img
                    src={IMAGES.factory}
                    alt="Heavy industrial factory interior"
                    className="h-full w-full object-cover opacity-40"
                />
            </motion.div>
            <div className="absolute inset-0 bg-gradient-to-b from-ink via-black/60 to-ink" />

            <div className="relative mx-auto max-w-screen-2xl px-6 md:px-12">
                <Chapter number="04" label="Infrastructure" />
                <FadeIn>
                    <h2 className="mb-16 max-w-5xl font-display text-4xl uppercase leading-[0.95] tracking-tight text-zinc-100 md:mb-24 md:text-7xl">
                        Built to <span className="text-outline-ember">industrial</span> scale
                    </h2>
                </FadeIn>
                <div className="grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
                    {STATS.map((s, i) => (
                        <FadeIn
                            key={s.label}
                            delay={i * 0.08}
                            className="bg-ink/80 p-8 backdrop-blur-sm md:p-10"
                        >
                            <div data-testid={`stat-${s.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                                <p className="font-display text-5xl tracking-tight text-zinc-100 md:text-6xl">
                                    {s.value}
                                    {s.unit && (
                                        <span className="ml-2 font-mono text-xs tracking-[0.2em] text-ember md:text-sm">
                                            {s.unit}
                                        </span>
                                    )}
                                </p>
                                <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500 md:text-xs">
                                    {s.label}
                                </p>
                            </div>
                        </FadeIn>
                    ))}
                </div>
            </div>
        </section>
    );
};
